import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ConfigurationService } from './services/configuration.service';
import { catchError } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class DataService {
    webApiEndpoint = this.configurationService.getWebApiEndpoint();

    constructor(
        private http: HttpClient,
        private configurationService: ConfigurationService,
        private router: Router,
    ) { }

    public get<T>(url: string, params?: HttpParams) {
        return this.http.get<T>(encodeURI(this.webApiEndpoint + url), { params, withCredentials: true }).
            pipe(catchError(error => { return of(error); })).pipe(map((value) => value.content));
    }

    public post<T>(url: string, body: any) {
        return this.http.post<T>(encodeURI(this.webApiEndpoint + url), body).
            pipe(catchError(error => of(error)));
    }

    public put<T>(url: string, body: any) {
        return this.http.put<T>(encodeURI(this.webApiEndpoint + url), body).
            pipe(catchError(error => of(error)));
    }

    public postAny(url: string, body: any, options: any) {
        return this.http.post(encodeURI(this.webApiEndpoint + url), body, options).
            pipe(catchError(error => of(error)));
    }

    public delete<T>(url: string) {
        return this.http.delete<T>(encodeURI(this.webApiEndpoint + url)).
            pipe(catchError(error => of(error)));
    }

    public deleteAny<T>(url: string, body: any = null) {
        return this.http.delete<T>(encodeURI(this.webApiEndpoint + url), body).
            pipe(catchError(error => of(error)));
    }

    public windowOpen(url: string, target: string = '_blank') {
        window.open(this.webApiEndpoint + url, target);
    }
}

